<template>
  <b-navbar type="dark" class="nav main-nav col-auto d-none d-md-flex px-3">
    <b-collapse id="bobcat-nav" is-nav>
      <template v-for="(item, i) in menuitems">
        <b-nav-item v-if="(!item.items && isAvailable(item)) || item.hideSubmenu"
                    :key="'primarymenu_'+i"
                    link-classes="position-relative d-flex align-content-center"
                    :data-test-id="'nav-main-item_'+i"
                    :href="item.url"
                    :active="item.active"
        >
          <b-icon v-if="item.icon && item.icon !== 'null'" :icon="item.icon" class="text-white mr-1" />
          <span class="d-none d-lg-inline-block ml-1 text-uppercase">{{ item.title }}</span>
        </b-nav-item>

        <b-nav-item v-else-if="isAvailable(item)"
                    :key="'primarymenu_'+i"
                    link-classes="position-relative d-flex align-content-center"
                    :data-test-id="'nav-main-item_'+i"
                    :active="item.active"
        >
          <b-icon v-if="item.icon && item.icon !== 'null'" :icon="item.icon" class="text-white mr-1" />
          <span class="d-none d-lg-inline-block ml-1 text-uppercase">{{ item.title }}</span>

          <MainSubnavigation :key="'secondarymenu_'+i"
                             :item="item"
                             :counter="i"
          />
        </b-nav-item>
      </template>
    </b-collapse>
  </b-navbar>
</template>

<script>
import MainSubnavigation from './MainSubnavigation'
import menuMixin from '@/mixins/menuMixin'

export default {
  components: {
    MainSubnavigation
  },
  mixins: [menuMixin],
  props: {
    menuitems: {
      type: Array,
      required: true
    }
  }
}
</script>
